import { TPlayerLayoutStylesSchema } from './PlayerLayout.styles';

const styles: Partial<TPlayerLayoutStylesSchema> = {
  row: {
    borderBottomWidth: '1px',
    borderColor: 'blackAlpha.400',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '2',
    px: '2.5',
  },
  btnGroupWrapper: {
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
    borderRadius: '5px',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
    boxShadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset',
    minW: '90px',
    gap: 'initial',
  },
  btnGroupText: {
    color: 'alpha.400',
    fontFamily: 'accent',
    fontWeight: 'normal',
    fontSize: 'sm',
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bg: 'beta.700',
    h: '100%',
    borderTop: '1px solid #626d77',
    borderBottom: '1px solid #626d77',
  },
  btnGroupIcon: {
    color: 'alpha.800',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.60)',
    sx: {
      filter: 'drop-shadow(0px 1px 0px rgba(255, 255, 255, 0.3))',
      h: '5',
      w: '7',
    },
  },
  name: {
    color: 'white',
  },
};
export default styles;
